import { useState, useRef, useEffect } from "react";
import { callAIApi , aiChatBotcall2chat } from "../services/apiService";
import { v4 as uuidv4 } from 'uuid';
import SpeechRecognition, {
  useSpeechRecognition,
  ListeningOptions
} from 'react-speech-recognition';
import "../custom.css";
import xorologo from "../assects/img/xoro-Logo.png";
import cutcall from "../assects/img/cut-cal.png";
import send from "../assects/img/Send45.png";
import videocall from "../assects/img/video-call.png";
import videocall2 from "../assects/img/video-camera2.png";
import mic from "../assects/img/mic.png";
import x_logo from "../assects/img/X_logo.png";

interface Message {
  sender: "user" | "bot" | "loading";
  text: string;
}

function CallAI2() {
  const [messages, setMessages] = useState<string[]>([]);
  const [loading, setLoading] = useState(false);
  const [current_user_chat_code, setCurrent_user_chat_code] = useState("");
  const [lastTranscript, setLastTranscript] = useState("");
  const [aiShortAnswer, setAiShortAnswer] = useState("");
    const [aiFullData, setAiFullData] = useState("");
    const [showFullData, setShowFullData] = useState(false);
    const [input, setInput] = useState("");
    const [messages2, setMessages2] = useState<Message[]>([]);

  const inactivityTimeoutRef = useRef<NodeJS.Timeout | null>(null);
  const videoRef = useRef<HTMLVideoElement | null>(null);
  const videoRef2 = useRef<HTMLVideoElement | null>(null);

  const {
    transcript,
    listening,
    resetTranscript,
    browserSupportsSpeechRecognition
  } = useSpeechRecognition();

  useEffect(() => {
    setCurrent_user_chat_code(uuidv4());
    const constraints = {
      audio: false,
      video: {
        facingMode: 'user' 
      }
    };

    navigator.mediaDevices.getUserMedia(constraints)
      .then((stream) => {
        if (videoRef.current) {
          videoRef.current.srcObject = stream;
        }
        if (videoRef2.current) {
          videoRef2.current.srcObject = stream;
        }
      })
      .catch((err) => {
        console.error("Error accessing camera:", err);
      });
  }, []);

  useEffect(() => {
    if (!transcript || transcript === lastTranscript) return;

    if (inactivityTimeoutRef.current) {
      clearTimeout(inactivityTimeoutRef.current);
    }

    inactivityTimeoutRef.current = setTimeout(() => {
      const clean = transcript.trim();
      if (clean) {
        setMessages((prev) => [...prev, clean]);
        setLastTranscript(clean);
        resetTranscript();
      }
    }, 1000);
  }, [transcript]);

  const handleBotReply = async () => {
    const fullConversation = messages.join(" ");
    if (!fullConversation.trim()) return;

    try {
      setLoading(true);

      const formData = new FormData();
      formData.append("userQuery", fullConversation);
      formData.append("current_user_chat_code", current_user_chat_code);

      const response = await callAIApi(formData);
      const cleanedReply = JSON.parse(response.reply.replace(/^```json\s*/, '') .replace(/```$/, '')) || "No response"
      console.log(response.reply)
      setAiShortAnswer(cleanedReply.short_answer.replace(/【.*?】/g, '') || "N/A");
      setAiFullData(cleanedReply.full_data.replace(/【.*?】/g, '') || "N/A");

      setShowFullData(false);

    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  const formatDateTime = () => {
  const now = new Date();

  const months = [
    'january', 'february', 'march', 'april', 'may', 'june',
    'july', 'august', 'september', 'october', 'november', 'december'
  ];

  const getOrdinalSuffix = (day: number) => {
    if (day > 3 && day < 21) return `${day}th`;
    switch (day % 10) {
      case 1: return `${day}st`;
      case 2: return `${day}nd`;
      case 3: return `${day}rd`;
      default: return `${day}th`;
    }
  };

  const month = months[now.getMonth()];
  const day = getOrdinalSuffix(now.getDate());
  const year = now.getFullYear();

  let hour = now.getHours();
  const minute = now.getMinutes().toString().padStart(2, '0');
  const ampm = hour >= 12 ? 'PM' : 'AM';

  hour = hour % 12;
  hour = hour ? hour : 12;

  return `${month} ${day},${year} ${hour}:${minute} ${ampm}`;
};

const handleBotReply2 = async (userInput: string) => {
    try {
      setLoading(true);

      const formData = new FormData();
      let audio = false;

     
    formData.append('userQuery', userInput);
    const userMessage: Message = { sender: "user", text: input };
    setMessages2((prev) => [...prev, userMessage]);
    setMessages2((prev) => [...prev, { sender: "loading", text: "🤖 Getting response..." }]);
      

      formData.append('current_user_chat_code', current_user_chat_code);

      const response = await aiChatBotcall2chat(formData);
      const userAudioText = response.transcribed_text;
      const botReply = response.reply || "No response";

      if (audio) {
        setMessages2((prev: any) => {
          const updated = prev.map((msg: any, index: number) => {
            if (index === prev.length - 2) {
              return { ...msg, text: `🎤 (voice message sent) - ${userAudioText}` };
            } else {
              return msg;
            }
          });
          return [...updated];
        });
      }

      setMessages2((prev) => {
        const filtered = prev.filter(msg => msg.text !== "🤖 Getting response...");
        return [...filtered, { sender: "bot", text: botReply }];
      });

      if (response.role !== "") {
        localStorage.setItem('userBotRole', response.role);
      }
    } catch (error) {
      setMessages2((prev) => [
        ...prev,
        { sender: "bot", text: "Sorry, something went wrong." },
      ]);
      setMessages2((prev) => {
        const filtered = prev.filter(msg => msg.text !== "🤖 Getting response...");
        return [...filtered];
      });
    } finally {
      setLoading(false);
    }
  };

  const sendMessage = async () => {
    const currentInput = input;
    setInput("");
    await handleBotReply2(currentInput);
  };


  if (!browserSupportsSpeechRecognition) {
    return <div>Browser doesn't support speech recognition</div>;
  }

  return (
    <div className="w-full h-screen flex flex-col bg-white">
      <div className="bg-white h-[70px] ps-5 text-white text-center py-4 text-xl font-semibold">
        <img src={xorologo} alt="Xoro Logo" className="w-auto h-full" />
      </div>

      <div className="flex justify-end w-full h-full px-5 pb-3">
        <div className="flex justify-between w-[97%] h-full">
            <div className="bg-white w-[40%]">
                {/* <button
                    onClick={() => {
                    const options: ListeningOptions = {
                        continuous: true,
                        language: 'en-US',
                    };
                    SpeechRecognition.startListening(options);
                    }}
                    disabled={loading}
                    className="px-5 py-3 font-bold rounded text-white bg-red-500 hover:bg-red-600 transition-colors"
                >
                    Start Call
                </button> */}
                <div className="h-[50px] w-full flex items-center">
                    <div className="w-fll h-[50%]">
                        <img src={videocall2} alt="Video Call" className="h-full w-auto"/>
                    </div>
                    <div className="vLine"></div>
                    <div style={{lineHeight: '3px'}} className="h-full">
                        <h2 className="font-bold text-2xl m-0 p-0">Acme Discovery Call</h2>
                        <small className="text-[10px]">{formatDateTime()}</small>
                    </div>
                </div>
                <div className="h-[300px] w-full mt-5">
                    <video ref={videoRef} autoPlay playsInline style={{ width: '100%', height: '100%', objectFit: 'cover' ,borderRadius: '10px'}} />
                </div>
                <div className="h-[300px] w-full mt-5 bg-black rounded">
                    {/* <video ref={videoRef2} autoPlay playsInline style={{ width: '100%', height: '100%', objectFit: 'cover' ,borderRadius: '10px'}} /> */}
                </div>
                <div className="h-[70px] w-[40%] m-auto flex items-center justify-between mt-5">
                    <img src={mic} alt="Image_1" className="w-auto h-full cursor-pointer"/>
                    <img src={videocall} alt="Image_2" className="w-auto h-full cursor-pointer"/>
                    <img src={cutcall} alt="Image_3" className="w-auto h-full cursor-pointer"/>
                </div>
            </div>
            <div className="w-[55%] bg-white flex flex-col items-center justify-start pt-6 space-y-4 callv2AIContainer px-5 relative">
                {/* <button
                    onClick={handleBotReply}
                    disabled={loading}
                    className={`px-6 py-2 font-bold rounded text-white transition-colors duration-200 ${
                    loading ? "bg-gray-400 cursor-not-allowed" : "bg-blue-600 hover:bg-blue-700"
                    }`}
                >
                    Help Me!
                </button> */}

                {/* <div className="w-[90%] bg-green-50 border border-green-400 p-4 rounded shadow text-sm text-gray-800">
                    <p className="text-green-700 font-semibold mb-2">AI Summary:</p>
                    <p className="mb-2">{aiShortAnswer || "No answer yet."}</p>

                    {aiFullData && !showFullData && (
                        <button
                        onClick={() => setShowFullData(true)}
                        className="text-blue-600 underline text-xs"
                        >
                        Show All Data
                        </button>
                    )}

                    {showFullData && (
                        <div className="mt-2 text-gray-700 whitespace-pre-wrap">
                        {aiFullData}
                        </div>
                    )}
                </div> */}

                <div className="ai-head1 w-full h-[60px] px-5 py-2 flex items-center mb-3">
                    <div className="w-auto h-full me-4"><img src={x_logo} alt="xoro Logo" className="w-auto h-full"/></div>
                    <p className="font-bold text-xl">MAUI - Live Story Assistant</p>
                </div>

                <div className="ai-tops w-full px-5 py-2 pb-5 mb-10 h-[160px] overflow-y-auto">
                    <h2 className="font-bold mb-1">Start the call with</h2>
                    <p style={{lineHeight: '1.2'}}>when begining of the conversation give two points of starting pitch for the call respective of the customer context.After bring the selected topic that i send to here</p>
                </div>

                <div className="w-full pt-7 ss-div relative h-[250px]">
                    <div className="w-full overflow-y-auto h-full">
                        <div className="ai-tops w-[95%] m-auto px-5 py-2 pb-5 mb-5 h-[100px]">
                            <h2 className="font-bold mb-1">Follow up topic 1</h2>
                            <p style={{lineHeight: '1.2'}}>Give two points from the follow up topic.</p>
                        </div>

                        <div className="ai-tops w-[95%] m-auto px-5 py-2 pb-5 h-[100px] mb-4">
                            <h2 className="font-bold mb-1">Follow up topic 2</h2>
                            <p style={{lineHeight: '1.2'}}>Give two points from the follow up topic.</p>
                        </div>
                    </div>
                    
                    <div className="absolute ss-h px-3 py-2">
                        <p className="text-white">STORY SUGGESTION</p>
                    </div>
                </div>

                <div className="ai-tops w-[95%] bg-white m-auto px-5 py-2 pb-5 bottom-24 z-50">
                    <h2 className="font-extrabold mb-3 italic qas"> Here's your answer for your question</h2>
                    <div className="w-full ai-tops px-3 py-2 h-[100px] overflow-y-auto" style={{lineHeight: '1.2'}}>
                        <small style={{opacity: 0.5}}>Start your question with the word "To your question." to get the answer here</small>
                    </div>
                </div>

                <div className="w-[100%] px-6 flex bg-white items-center h-[60px] bottom-5 z-50">
                    <div className="flex items-center justify-between bg-white rounded-full sha1 px-4 pe-2 py-2 w-[70%] m-auto h-[60px]">
                        <input
                        type="text"
                        value={input}
                        onChange={(e) => setInput(e.target.value)}
                        placeholder="What’s in your mind?…"
                        className="flex-1 px-2 py-1 text-sm bg-transparent focus:outline-none w-[95%]"
                        />
                        <button onClick={() => sendMessage()} disabled={loading} className="h-full py-0.5 w-auto">
                            {loading ? <img src={send} alt="send" className="w-full h-full"/> : <img src={send} alt="send" className="w-full h-full"/>}
                        </button>
                    </div>
                </div>
            </div>
        </div>
      </div>
    </div>
  );
}

export default CallAI2;
